export default {
    dashboard: 'Panel',
    files: 'Pliki',
    filesUpload: 'Prześlij pliki',
    fileEdit: 'Edytuj plik',
    invoices: 'Faktury',
    invoiceAdd: 'Dodaj fakturę',
    invoiceEdit: 'Edytuj fakturę',
    invoiceCorrection: 'Korekta faktury',
    login: 'Logowanie',
    notFound: 'Nie znaleziono',
    settings: 'Ustawienia',
    settingsKsef: 'Ustawienia KSeF',
    settingsMailing: 'Ustawienia mailingu',
    settingsTwoFactor: 'Logowanie dwuetapowe',
    ksef: 'KSeF',
    ksefInvoiceDetail: 'KSeF Faktura',
    crm: 'Kontrahenci',
    crmNewSimplified: 'Nowy kontrahent uproszczony',
    crmEditSimplified: 'Edytuj kontrahenta uproszczonego',
    crmNewFull: 'Nowy kontrahent',
    crmEditFull: 'Edytuj kontrahenta',
};
